import React from "react";
import "../styles/Contact.css";
import SendMessage from "../assets/letter_send.svg";

export default function Contact() {
  return (
    <div className="contact">
      <div className="contact-form">
        <h1>
          I've Been <span>Waiting For You</span>
        </h1>
        <div className="contact-details-row">
          <div className="contact-details">
            <div className="input-fields">
              <label for="first-name">First Name</label>
              <input type="text" name="first-name" />
            </div>
          </div>
          <div className="contact-details">
            <div className="input-fields">
              <label for="last-name">Last Name</label>
              <input type="text" name="last-name" />
            </div>
          </div>
        </div>
        <div className="contact-details-row">
          <div className="contact-details">
            <div className="input-fields">
              <label for="email">Email</label>
              <input type="email" name="email" />
            </div>
          </div>
          <div className="contact-details">
            <div className="input-fields">
              <label htmlFor="phone-number">Phone Number</label>
              <input type="tel" name="phone-number" id="phone-number" />
            </div>
          </div>
        </div>
        <div className="contact-details-row">
          <div className="input-fields">
            <label>Select Subject?</label>
            <div className="radio-buttons">
              <div>
                <input
                  type="radio"
                  id="brand-identity"
                  name="choices"
                  value="brand-identity"
                />
                <label for="brand-identity">Brand Identity</label>
              </div>
              <div>
                <input type="radio" id="ui/ux" name="choices" value="ui/ux" />
                <label for="ui/ux">UI/UX</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="packaging-design"
                  name="choices"
                  value="packaging-design"
                />
                <label for="packaging-design">Packaging Design</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="web-development"
                  name="choices"
                  value="web-development"
                />
                <label for="web-development">Web Development</label>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-details-row">
          <div className="input-fields">
            <label htmlFor="message">Message</label>
            <div>
              <textarea
                id="message"
                name="message"
                rows="4"
                cols="120"
                placeholder="Write your message"
              ></textarea>
            </div>
          </div>
        </div>
        <div className="send-button">
          <button type="submit">Send Message</button>
        </div>
        <div className="image">
          <img src={SendMessage} alt="Send Message" />
        </div>
      </div>
    </div>
  );
}
